import useCartStore from "../../utils/cartStore";
import { useState } from "react";

const GOUTS_ORIENT = [
  { id: "noir", label: "Chocolat noir, dattes, sésame & pistache", color: "#1a1a1a" },
  { id: "lait", label: "Chocolat au lait, pâte d'amande & fleurs d'oranger", color: "#C68642" },
];

const REPARTITION_VIDE = Object.fromEntries(GOUTS_ORIENT.map((g) => [g.id, 0]));

const CarresOrientCard = () => {
  const addToCart = useCartStore((state) => state.addToCart);
  const [quantity, setQuantity] = useState(1);
  const [repartition, setRepartition] = useState({ ...REPARTITION_VIDE });

  const total = Object.values(repartition).reduce((a, b) => a + b, 0);
  const restant = 16 - total;
  const pret = total === 16;

  const handleIncrease = (id) => {
    if (restant <= 0) return;
    setRepartition((prev) => ({ ...prev, [id]: prev[id] + 1 }));
  };

  const handleDecrease = (id) => {
    if (repartition[id] <= 0) return;
    setRepartition((prev) => ({ ...prev, [id]: prev[id] - 1 }));
  };

  const buildDescription = () => {
    return GOUTS_ORIENT.filter((g) => repartition[g.id] > 0)
      .map((g) => `${repartition[g.id]}x ${g.label}`)
      .join(", ");
  };

  const handleAddToCart = () => {
    if (!pret) return;
    addToCart({
      id: `carres-orient-${Date.now()}`,
      name: "Carrés d'Orient",
      price: 32,
      image: "/images/carres-orient/carres-orient.jpg",
      category: "Carrés d'Orient",
      description: buildDescription(),
    }, quantity);
    setRepartition({ ...REPARTITION_VIDE });
    setQuantity(1);
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6 max-w-lg mx-auto">
      <img
        src="/images/carres-orient/carres-orient.jpg"
        alt="Carrés d'Orient"
        className="w-full h-64 object-cover rounded-xl mb-4"
      />
      <h2 className="text-2xl font-semibold mb-1">Carrés d'Orient</h2>
      <p className="text-gray-500 text-sm mb-3">
        Boîte de 16 pièces — personnalisez le mélange des goûts
      </p>
      <p className="text-xl font-bold mb-6">32 €</p>

      {/* Répartition des 16 carrés */}
      <div className="mb-5">
        <p className="text-sm font-semibold mb-2 text-gray-700">
          Répartissez vos 16 carrés :
        </p>
        <div className={`text-xs font-medium mb-3 px-3 py-1 rounded-full inline-block ${
          pret ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"
        }`}>
          {pret ? "✓ Sélection complète !" : `${restant} carré${restant > 1 ? "s" : ""} restant${restant > 1 ? "s" : ""}`}
        </div>

        <div className="space-y-3">
          {GOUTS_ORIENT.map((g) => {
            const count = repartition[g.id];
            const isDark = g.id === "noir";
            return (
              <div key={g.id} className="flex items-center gap-3">
                <span
                  className="w-10 h-10 rounded-lg flex-shrink-0 border border-gray-200 flex items-center justify-center"
                  style={{ background: g.color }}
                >
                  <span className={`text-xs font-bold ${isDark ? "text-white" : "text-gray-700"}`}>
                    {g.id === "noir" ? "N" : "L"}
                  </span>
                </span>
                <span className="text-sm text-gray-700 flex-1">{g.label}</span>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleDecrease(g.id)}
                    disabled={count === 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${
                      count === 0
                        ? "border-gray-200 text-gray-300 cursor-not-allowed"
                        : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"
                    }`}
                  >−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button
                    onClick={() => handleIncrease(g.id)}
                    disabled={restant <= 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${
                      restant <= 0
                        ? "border-gray-200 text-gray-300 cursor-not-allowed"
                        : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"
                    }`}
                  >+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Quantité */}
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-8 h-8 border rounded">−</button>
        <span>{quantity}</span>
        <button onClick={() => setQuantity(quantity + 1)} className="w-8 h-8 border rounded">+</button>
      </div>

      <button
        onClick={handleAddToCart}
        disabled={!pret}
        className={`w-full py-2 rounded-xl font-semibold transition-colors ${
          pret ? "btn-primary cursor-pointer" : "bg-gray-200 text-gray-400 cursor-not-allowed"
        }`}
      >
        {pret ? "Ajouter au panier" : "Complétez votre sélection"}
      </button>
    </div>
  );
};

const CarresOrient = () => {
  return (
    <div className="section-padding">
      <h1 className="text-4xl font-bold mb-4">Carrés d'Orient</h1>
      <p className="text-gray-500 mb-2 max-w-2xl">
        Laissez-vous emporter par une parenthèse de douceur où tradition et gourmandise se rencontrent.
      </p>
      <p className="text-gray-500 mb-12 max-w-2xl">
        Des créations chocolatées imaginées pour accompagner vos moments de partage, sublimer vos tables — ou simplement offrir un instant de plaisir raffiné à ceux que vous aimez.
      </p>
      <div className="flex justify-center">
        <CarresOrientCard />
      </div>
    </div>
  );
};

export default CarresOrient;